"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowKeyedGridSelection = void 0;
/**
 * Useful if you are only toggling the selection state of entire rows, or if your row indexes are unknowable or unstable.
 * Keys are the `key` field of the `Row`, value is `true` if selected.
 *
 * @see `IndexBasedGridSelection`
 *
 * @example
 * const MyComponent: React.FC = () => {
 *   const [selectionModel] = React.useState(new RowKeyedGridSelection()); // could also use a ref here; useState syntax is slightly cleaner
 *
 *   // this particular handler only allows one row to be selected at a time
 *   const handleSelectionEvent: React.useCallback<CellSelectionHandler>(e => {
 *     if (selectionModel.isSelected(e.cell)) {
 *       return false; // row is already selected
 *     }
 *
 *     selectionModel.clearSelection();
 *     selectionModel.toggleRowSelect(e.cell.rowKey, true);
 *     // here is where you might signal something outside the component that the selection changed
 *
 *     return true; // let the DataGrid know that the selection data was updated
 *   }, [selectionModel]);
 *
 *   return <DataGrid selectionModel={selectionModel} onSelectionEvent={handleSelectionEvent} {...otherPropsHere} />;
 * }
 */
var RowKeyedGridSelection = /** @class */ (function () {
    function RowKeyedGridSelection(selectionData) {
        this.selectionData = selectionData || {};
    }
    RowKeyedGridSelection.prototype.clearSelection = function () {
        this.selectionData = {};
    };
    RowKeyedGridSelection.prototype.isSelected = function (cell) {
        return !!cell.rowKey && this.selectionData[cell.rowKey];
    };
    RowKeyedGridSelection.prototype.toggleRowSelect = function (rowKey, select) {
        if (!rowKey) {
            throw new Error("rowKey must be defined");
        }
        if (select === null || select === undefined) {
            select = !this.selectionData[rowKey];
        }
        // wondering if we should `delete` in the !select case... --ckovatch
        this.selectionData[rowKey] = select;
    };
    return RowKeyedGridSelection;
}());
exports.RowKeyedGridSelection = RowKeyedGridSelection;
//# sourceMappingURL=RowKeyedGridSelection.js.map